<div
  *ngIf="user != null"
  class="clickable impersonate-icon"
  [class.disabled]="user?.id == null"
  [matTooltip]="
    user?.id != null
      ? 'Nabootsen'
      : 'Nabootsen niet mogelijk, geen gebruiker gevonden'
  "
  (click)="impersonateUser()"
>
  <mat-icon>group</mat-icon>
</div>
